const data = [
	{
		seminar: `Organized one day workshop of syllabus exploration of subject Discrete mathematics 
		(2019 course) sponsored by SPPU`,
	},
	{
		seminar: `Organized One Week FDP on “Data Science” under PMMMNMTT scheme an initiative of 
		MHRD`,
	},
	{
		seminar: `Organized Five days FDP on “Advanced Java Programming & Mobile Application 
		Development” from 12th
		-16th June 2017.`,
	},
	{
		seminar: `Organized Three days FDP on “Cloud Computing: Nut and Bolts” from 2nd
		-4
		th January 
		2016`,
	},
	{
		seminar: `Organized One day FDP on “Data Structure & Algorithms on 11th June 2016`,
	},
	{
		seminar: `Organized Two days FDP on “ Research Instrumentation Talks & Tools “ from 8th
		-9
		th
		January 2016
		`,
	},
	{
		seminar: `Organized Three days FDP on” Smart System Programming” from 24th – 26th July 2015`,
	},
	{
		seminar: `Organized Five days FDP on “CUDA & Open MP” from 17th
		– 21st December 2014.
		`,
	},
	{
		seminar: `Organized Five days FDP on “Multicore Programming” 24th
		- 28 December 2013`,
	},
	{
		seminar: `Organized Three days FDP on “Operating System & Administration” from 5th
		-7
		th July 
		2013.`,
	},
	{
		seminar: `. Organized Two days FDP on “Multicore Architecture & Programming “from 29th
		-30th
		June 2013.`,
	},
	{
		seminar: `Organized Five days FDP on “High Performance Computing” from 11th
		– 15th October 
		2012`,
	},
	{
		seminar: `Organized Five days FDP on “Applied Algorithms” from 9th may -13th may 2012`,
	},
	{
		seminar: `Organized Five days FDP on “Cloud Computing” from 16th
		-20th November 2011`,
	},
	{
		seminar: `Organized Five days FDP on “Oracle & Advanced .NET “from 15th
		– 19th January 2011.
		`,
	},
	{
		seminar: `Organized One day workshop for the faculties “B.E Project Guidelines” on 18th
		September 2011.
		`,
	},
];

export default data;
